<app-inventory-template
  [inventoryOptions]="{
  items_load_endpoint: 'load_market_inventory',
  items_load_endpoint_options: {
    balance: type(),
    type: 'balance',
  },
  items_search_enabled: true,
  items_sort_enabled: true,
  items_pure_filter_enabled: false,
  typography_action_button: type() === 'pure' ? 'Deposit Pure Items' : 'Deposit Skins Items',
  typography_title: type() === 'pure' ? 'Deposit Pure Balance' : 'Deposit Skins Balance',
}"
  [requirementsOptions]="{
    requirements_title: type() === 'pure' ? 'Deposit Pure Items' : 'Deposit Skins Items',
    requirements_accent_word: 'deposit',
    requirements_options_min_value: 1,
    requirements_options_max_value: 9999,
    requirements_options_min_items: 1,
    requirements_options_max_items: 50,
  }"
  [inventorySkinsListConfig]="{
    columns: 8,
    responsive_columns: true,
    skin_min_width: '100px',
  }"
  [pure]="type() === 'pure'"
  [(selectedSkins)]="selectedSkins"
  [isProcessing]="isProcessing()"
  (action)="depositItems()"
/>
